import { IConfig } from '../../../url-reader';
import { useEffect } from 'react';
import { Nullable } from '../../../shared/types/Typescript-utils';

const baseUrl = window._env_.BASE_URL;
const iframePopupSource = baseUrl + '/tint/popup.html';

const createPopupIFrame = (): void => {
  const popupIframe = document.createElement('iframe');
  popupIframe.setAttribute('src', iframePopupSource);
  popupIframe.setAttribute('id', 'tint-popup');
  popupIframe.setAttribute('allow', 'fullscreen');

  popupIframe.style.display = 'none';
  popupIframe.style.position = 'fixed';
  popupIframe.style.width = '100%';
  popupIframe.style.height = '100%';
  popupIframe.style.left = '0px';
  popupIframe.style.right = '0px';
  popupIframe.style.top = '0px';
  popupIframe.style.bottom = '0px';
  popupIframe.style.border = 'none';
  popupIframe.style.zIndex = '9999999';
  window?.document?.body?.appendChild(popupIframe);
};

const useCreatePopup = (config: Nullable<IConfig>): void => {
  useEffect(() => {
    if (config?.innerIFrame) {
      createPopupIFrame();
    }
  }, [config?.innerIFrame]);
};

export default useCreatePopup;
